import IOrder from "../../../models/IOrder";
import UserService from "../../../services/UserService";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./DailyRouteDoNotShipWarningModal.scss";

type Props = {
    excludedOrders: IOrder[];
    routeDate: string;
    proceedFn: () => void;
    cancelFn: () => void;
};

export const DailyRouteDoNotShipWarningModal = (props: Props) => {
    return (
        <div className="DailyRouteDoNotShipWarningModal p-4">
            <OwTitle title="do_not_ship_before_warning" leftIconName="fad fa-calendar-exclamation" tag="h4" />

            <div className="mt-3">
                <p className="text-warning mb-1">
                    <OwLabel title="do_not_ship_before_warning_description" />
                </p>
            </div>

            <div className="order-list mt-3 mb-3">
                {props.excludedOrders.map((order) => (
                    <div key={order.guid} className="order-item d-flex justify-content-between">
                        <span className="order-name">{order.name}</span>
                        <span className="order-dns-date text-muted ms-2">
                            <OwLabel title="do_not_ship_before" className="me-1" />
                            {UserService.parseDate(order.do_not_ship_before_date)}
                        </span>
                    </div>
                ))}
            </div>

            <div className="warning-notes mt-3">
                <div className="note">
                    <i className="fas fa-info-circle text-warning me-2" />
                    <OwLabel title="do_not_ship_before_remove_and_proceed" />
                </div>
            </div>

            <div className="mt-4 text-center">
                <OwButton title="remove_and_proceed" fn={props.proceedFn} />
                <OwButton title="cancel" className="ms-2 text-danger" fn={props.cancelFn} />
            </div>
        </div>
    );
};
